import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form/immutable';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import './auth.css';
import misc from '../../misc';
import SignupConfirm from './SignupConfirm';

export class Signup extends Component {
  render() {
    if (this.props.submitSucceeded === true) {
      return <SignupConfirm />;
    }

    const { pristine, submitting, handleSubmit, error } = this.props;

    return (
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col-md-6">
            <form onSubmit={handleSubmit(this.props.onSubmit)}>
              <div className="text-center m-4">
                <img
                  src={misc.images.logoGrey3}
                  width="30"
                  height="30"
                  className="d-inline-block align-top"
                  alt="Federation"
                />
                <h2 className="mb-1 d-inline-block align-bottom">
                  &nbsp;Sign Up
                </h2>
              </div>

              {/*
              <a href="/api/auth/google" className="btn btn-lg btn-primary btn-block">
                <span className="icon icon-google-plus" /> Sign Up with Google
              </a>
              <div className="text-center m-4">
                &mdash; <em>or</em> &mdash;
              </div>
              */}

              {error && <misc.components.Alert message={error} />}
              <div className="row">
                <div className="col">
                  <Field
                    component={misc.components.FormField}
                    name="firstName"
                    id="firstName"
                    type="input"
                    label="First name"
                    required
                    autoFocus
                  />
                </div>
                <div className="col">
                  <Field
                    component={misc.components.FormField}
                    name="lastName"
                    id="lastName"
                    type="input"
                    label="Last name"
                    required
                  />
                </div>
              </div>
              <Field
                component={misc.components.FormField}
                name="email"
                id="email"
                type="email"
                label="Email address"
                required
              />
              <Field
                component={misc.components.FormField}
                name="password"
                id="password"
                type="password"
                label="Password"
                required
              />
              <Field
                component={misc.components.FormField}
                name="passwordConfirm"
                id="passwordConfirm"
                type="password"
                label="Confirm password"
                required
              />
              <misc.components.LoadingButton
                className="btn-lg"
                disabled={pristine || submitting}
                loading={this.props.isLoading}
              >
                Sign Up
              </misc.components.LoadingButton>
              <div className="text-center mt-3">
                Already registered? <Link to="/auth/login">Login</Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

Signup.propTypes = {
  errorMessage: PropTypes.string,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired
};

Signup.defaultProps = {
  isLoading: false,
  isError: false,
  errorMessage: 'Sorry, an error occurred.'
};

export function validate(values) {
  const errors = {};

  // Email
  if (!values.get('email')) {
    errors.email = true;
  } else if (!misc.lib.validators.validateEmail(values.get('email'))) {
    errors.email = 'Email address is invalid';
  }

  // Password
  if (!values.get('password')) {
    errors.password = true;
  } else if (!misc.lib.validators.validatePassword(values.get('password'))) {
    errors.password =
      'Password must have a minimum of 8 characters including uppercase, lowercase, and digits';
  }

  // Password confirmation
  if (!values.get('passwordConfirm')) {
    errors.passwordConfirm = true;
  } else if (values.get('password') !== values.get('passwordConfirm')) {
    errors.passwordConfirm = 'Passwords do not match';
  }

  return errors;
}

export default reduxForm({
  validate,
  form: 'signupForm'
})(Signup);



// WEBPACK FOOTER //
// ./src/modules/auth/components/Signup.js